"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/// <reference types="jquery"/>
var vue_1 = __importDefault(require("vue"));
var form_radio_group_1 = __importDefault(require("bootstrap-vue/es/components/form-radio/form-radio-group"));
var form_checkbox_group_1 = __importDefault(require("bootstrap-vue/es/components/form-checkbox/form-checkbox-group"));
var SelectCustom_vue_1 = __importDefault(require("./SelectCustom.vue"));
var CheckBox_vue_1 = __importDefault(require("./CheckBox.vue"));
var TextOutput_vue_1 = __importDefault(require("../Output/TextOutput.vue"));
var ConditionalDisplay_1 = __importDefault(require("../../Mixins/ConditionalDisplay"));
var PredicateInput_1 = __importDefault(require("../../Mixins/PredicateInput"));
var SourceValue_1 = __importDefault(require("../../Mixins/SourceValue"));
exports.default = vue_1.default.extend({
    props: ['name', 'label', 'required', 'nameSelect', 'nameRadioGlobalePartielle', 'nameRadioEtudeTravaux'],
    components: { SelectCustom: SelectCustom_vue_1.default, CheckBox: CheckBox_vue_1.default, bFormRadioGroup: form_radio_group_1.default, bFormCheckboxGroup: form_checkbox_group_1.default, TextOutput: TextOutput_vue_1.default },
    mixins: [ConditionalDisplay_1.default, PredicateInput_1.default, SourceValue_1.default],
    data: function () {
        var model = this.$root.$data;
        return {
            idActe: null,
            sstGlobalePartielle: model.data[this.nameRadioGlobalePartielle] || 0,
            choixGlobalePartielle: false,
            optionTypeSst: [
                { text: "Globale", value: 1 },
                { text: "Partielle", value: 2 }
            ],
            sstEtudeTravaux: model.data[this.nameRadioEtudeTravaux] || 0,
            radioEtuTvx: [],
            choixEtudeTvx: false,
            optionTypePhaseSst: [
                { text: "Etudes", value: 1 },
                { text: "Travaux", value: 2 }
            ],
            readonly: model.readOnly
        };
    },
    mounted: function () {
        var _this = this;
        var select = this.$refs.select;
        if (select !== undefined && select.value != null) {
            var a = JSON.parse(select.selected);
            var isEtude = a.SsTEtudeGlobale == true || a.SsTEtudePartielle == true;
            var isTvx = a.SsTTravauxGlobale == true || a.SsTTravauxPartielle == true;
            var sousTraitranceEtuGlobalePartielle = a.SsTEtudeGlobale == true && a.SsTEtudePartielle == true ? "étude (globale / partielle)" :
                a.SsTEtudeGlobale == true ? "étude globale" :
                    a.SsTEtudePartielle == true ? "étude partielle" :
                        "";
            var sousTraitranceTvxGlobalePartielle = a.SsTTravauxGlobale == true && a.SsTTravauxPartielle == true ? "travaux (globale / partielle)" :
                a.SsTTravauxGlobale == true ? "travaux globale" :
                    a.SsTTravauxPartielle == true ? "travaux partielle" :
                        "";
            var text = "Acte numéro" + a.NumActe + " - " + a.NomSousTraitant + "(Sous-traitance " + sousTraitranceEtuGlobalePartielle + (isEtude == true && isTvx == true ? " / " : "") + sousTraitranceTvxGlobalePartielle + ")";
            select.value = text;
            this.idActe = a.Id;
            this.choixGlobalePartielle =
                (a.SsTEtudeGlobale == true && a.SsTEtudePartielle == true) ||
                    (a.SsTTravauxGlobale == true && a.SsTTravauxPartielle == true);
            this.choixEtudeTvx = isEtude && isTvx;
            if (this.choixEtudeTvx === true) {
                if (this.sstEtudeTravaux.toString() === "1" || this.sstEtudeTravaux.toString() === "2") {
                    this.radioEtuTvx = [this.sstEtudeTravaux];
                }
                else {
                    this.radioEtuTvx = [1, 2];
                }
            }
        }
        this.$watch("$refs.select.selected", function (new_value) {
            var a = JSON.parse(new_value);
            _this.idActe = a.Id;
            var isEtude = a.SsTEtudeGlobale == true || a.SsTEtudePartielle == true;
            var isTvx = a.SsTTravauxGlobale == true || a.SsTTravauxPartielle == true;
            _this.choixGlobalePartielle =
                (a.SsTEtudeGlobale == true && a.SsTEtudePartielle == true) ||
                    (a.SsTTravauxGlobale == true && a.SsTTravauxPartielle == true);
            _this.choixEtudeTvx = isEtude && isTvx;
            if (!_this.choixGlobalePartielle) {
                if (a.SsTEtudeGlobale == true || a.SsTTravauxGlobale == true) {
                    _this.sstGlobalePartielle = _this.optionTypeSst[0].value;
                }
                if (a.SsTEtudePartielle == true || a.SsTTravauxPartielle == true) {
                    _this.sstGlobalePartielle = _this.optionTypeSst[1].value;
                }
            }
            else {
                _this.sstGlobalePartielle = null;
            }
            if (!_this.choixEtudeTvx) {
                if (isEtude == true) {
                    _this.sstEtudeTravaux = _this.optionTypePhaseSst[0].value;
                }
                if (isTvx == true) {
                    _this.sstEtudeTravaux = _this.optionTypePhaseSst[1].value;
                }
            }
            else {
                _this.sstEtudeTravaux = null;
            }
        });
        this.$watch("radioEtuTvx", function (new_value) {
            if (new_value.length > 1) {
                _this.sstEtudeTravaux = 3;
            }
            else {
                _this.sstEtudeTravaux = new_value[0];
            }
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/Workflow/Components/Input/OzSelectActe.vue
// module id = 191
// module chunks = 0